import { Injectable } from '@angular/core';

export interface Credentials {
  // Customize received credentials here
  username: string;
  token: string;
  companyId: string;
  refreshToken: string;
  companyName: string;
}

const credentialsKey = 'credentials';
const xOtpKey = 'x-otp';

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  private _credentials: Credentials | null = null;
  private _otpCredentials: Credentials | null = null;

  constructor() {
    const savedCredentials =
      sessionStorage.getItem(credentialsKey) ||
      localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    const savedCredentials =
      sessionStorage.getItem(credentialsKey) ||
      localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
    return this._credentials;
  }

  /**
   * Gets the airline passenger otp credentials.
   * @return The airline passenger otp credentials or null if the airline passenger is not authenticated.
   */
  get otpCredentials(): Credentials | null {
    const savedCredentials =
      sessionStorage.getItem(xOtpKey) || localStorage.getItem(xOtpKey);
    if (savedCredentials) {
      this._otpCredentials = JSON.parse(savedCredentials);
    }
    return this._otpCredentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      // const storage = remember ? localStorage : sessionStorage;
      const storage = localStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }

  /**
   * Sets the airline passenger otp credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The airline passenger otp credentials.
   * @param remember True to remember credentials across sessions.
   */
  setOtpCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      // const storage = remember ? localStorage : sessionStorage;
      const storage = localStorage;
      storage.setItem(xOtpKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(xOtpKey);
      localStorage.removeItem(xOtpKey);
    }
  }
}
